// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"fa0a71d7","132":"00061f44","264":"78467347","338":"b2d6e8cc","387":"125874e6","396":"fffb67b9","409":"ebabb8b6","527":"fc2a7fd2","546":"94a1b9d4","599":"0b38eb2f","641":"97780368","705":"0cb1a2e4","825":"3f47e3a7"}[chunkId] + ".chunk.js";
};